export default function redirectTo (url) {
  window.location.href = url
}
